import { styled } from '@/styled-system/jsx';
import { css } from '@/styled-system/css';

export const noUserSelectClass = css({
  userSelect: 'none',
  '& *': {
    userSelect: 'none',
  },
});

export const zIndexTransitionClass = css({
  animation: 'zIndexTransitioning',
});

export const hamburgerOpenClass = css({
  zIndex: 'zIndexOverlay',
});

export const StyledListingNavBar = styled('div', {
  base: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 'hdpNavBarHeightMd',
    marginTop: 'calc(token(sizes.hdpNavBarHeightMd) * -1)',
    zIndex: 'zIndexOverParent',
    backgroundColor: 'hpxWhite',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',

    md: {
      width: 'sidebarWidthMdBiggerListingCards',
    },

    xxl: {
      width: 'sidebarWidthXlBiggerListingCards',
      height: 'hdpNavBarHeightXl',
      marginTop: 'calc(token(sizes.hdpNavBarHeightXl) * -1)',
    },
  },
});

export const LeftSection = styled('div', {
  base: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
});

export const RightSection = styled('div', {
  base: {
    height: '100%',
  },
});

export const XIcon = styled('img', {
  base: {
    width: '16px',
    height: '16px',
    marginTop: '-2px',
    marginRight: '16px',
    marginBottom: '0',
    marginLeft: '16px',
  },
});

export const BackText = styled('span', {
  base: {
    marginLeft: '2x',
    fontSize: 'sm',
    lineHeight: 'sm',
    color: 'inherit',

    '[data-group]:hover &': {
      color: 'hpxBlue600',
    },
  },
});

export const LandingContainer = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
  },
});

export const NavNextLeft = styled('div', {
  base: {
    alignItems: 'center',
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'hpxGrey100',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    marginLeft: '1x',
    paddingTop: '4px',
  },
});

export const MobileNavNextLeft = styled(NavNextLeft, {
  base: {
    paddingLeft: '1x',
  },
});

export const MoreListingsText = styled('div', {
  base: {
    color: 'hpxTeal500',
    fontSize: 'tiny',
    lineHeight: 'tiny',
    textAlign: 'left',

    xl: {
      fontSize: 'sm',
      lineHeight: 'sm',
    },
  },
});

export const FavMenu = styled('div', {
  base: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

export const FavButton = styled('button', {
  base: {
    transitionProperty: 'all',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease-in-out',
    userSelect: 'none',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '56px',
    height: '100%',
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'hpxGrey100',
    borderTop: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderRadius: '0',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    padding: '0',
    margin: '0',
    font: 'inherit',
    color: 'inherit',
    appearance: 'none',
    outline: 'none',

    _hover: {
      cursor: 'pointer',
      backgroundColor: 'hpxGrey100',
    },

    _focus: {
      outline: 'none',
    },
  },
});

export const FavIcon = styled('div', {
  base: {
    width: '22px',
    height: '22px',
  },
});

export const AnimationIcon = styled('div', {
  base: {
    height: {
      base: '42px',
      xl: '48px',
    },
    width: {
      base: '42px',
      xl: '48px',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const ShareButton = styled('button', {
  base: {
    transitionProperty: 'all',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease-in-out',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '48px',
    height: '100%',
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'hpxGrey100',
    borderTop: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderRadius: '0',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    padding: '0',
    margin: '0',
    font: 'inherit',
    color: 'inherit',
    appearance: 'none',
    outline: 'none',

    xl: {
      width: '56px',
    },

    _hover: {
      cursor: 'pointer',
      backgroundColor: 'hpxGrey100',
    },

    _focus: {
      outline: 'none',
    },
  },
  variants: {
    expanded: {
      true: {
        backgroundColor: 'hpxGrey100',
      },
    },
  },
});

export const MenuButton = styled('button', {
  base: {
    transitionProperty: 'all',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease-in-out',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '48px',
    height: '100%',
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'hpxGrey100',
    borderTop: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderRadius: '0',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    padding: '0',
    margin: '0',
    font: 'inherit',
    color: 'inherit',
    appearance: 'none',
    outline: 'none',

    xl: {
      width: '56px',
    },

    _hover: {
      cursor: 'pointer',
      backgroundColor: 'hpxGrey100',
    },

    _focus: {
      outline: 'none',
    },
  },
  variants: {
    expanded: {
      true: {
        backgroundColor: 'hpxGrey100',
      },
    },
  },
});

export const BuildingIconWrapper = styled('img', {
  base: {
    width: '20px',
    height: '20px',
    marginRight: '2x',
  },
});

export const ShareIconWrapper = styled('img', {
  base: {
    width: '20px',
    height: '20px',
  },
});

export const MenuIconWrapper = styled('img', {
  base: {
    width: '20px',
    height: '20px',
    marginTop: {
      base: '18px',
      md: '16px',
    },
  },
});

export const navHardLeftSSRClass = css({
  width: '60px',
  height: '100%',
  paddingTop: '0',
  paddingRight: '8px',
  paddingBottom: '0',
  paddingLeft: '8px',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',

  xl: {
    width: '100%',
    paddingTop: '0',
    paddingRight: '16px',
    paddingBottom: '0',
    paddingLeft: '16px',
  },
});

export const navHardLeftClass = css({
  height: '100%',
  cursor: 'pointer',
  paddingRight: '1x',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  xl: {
    paddingRight: '2x',
  },
});

export const navHardMobileClass = css({
  paddingRight: '0',
});

export const StyledVertCenterContainer = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
});

export const vertCenterLinkerClass = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

export const animationClass = css({
  width: '100%',
  height: '100%',
});
